export default [

     {
          path: '/escalation-action',
          name: 'EscalationAction',
          component: () => import("@/views/Page/EscalationAction/EscalationAction.vue"),
           meta: {
               title: '#Default# | EscalationAction',
          },
     }
];